import './DataTable.css';
export var dataTable = '_14sp6az0-3-8-0';
export var firstBodyRow = '_14sp6az5-3-8-0';
export var fullWidth = '_14sp6az1-3-8-0';
export var lastBodyRow = '_14sp6az6-3-8-0';
export var notResizing = '_14sp6az2-3-8-0';
export var pinnedCellInDragOverlay = '_14sp6az4-3-8-0';
export var prefixColumn = '_14sp6az3-3-8-0';